var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('RidersListIndex',{attrs:{"fst-id":("franchise-riders-page_" + _vm.getId),"qso":_vm.getEndpointOptions,"pageTitle":_vm.title,"endpoint":_vm.getEndpoint,"filterItems":_vm.filterOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }